import React from "react";
import { useFeatureFlags } from "../contexts/FeatureFlagsContext";

interface FeatureProps {
  name: keyof ReturnType<typeof useFeatureFlags>["flags"];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Component to conditionally render children based on a feature flag.
 */
export const Feature: React.FC<FeatureProps> = ({ name, children, fallback = null }) => {
  const { isEnabled } = useFeatureFlags();

  if (isEnabled(name)) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};
